import styled from 'styled-components';
import { Colors, FontSizes } from '../../utils/style';

export default styled.h3`
  color: ${Colors.Black};
  font-size: ${FontSizes.Large}px;
  font-weight: bold;
`;
